import { message } from 'antd';
import { put, select, takeLatest } from 'redux-saga/effects';
import {
  PhaseEntityType,
  converToEntityId,
} from 'components/organisms/projects/project-plan/phase-entity';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import {
  addTaskAboveProjectTemplate,
  addTaskBelowProjectTemplate,
  TaskIdPayload,
} from '../../actions';
import { selectTemplateTask } from '../../selectors';
import {
  createProjectTemplateSubTask,
  createProjectTemplateTask,
} from '../../slices';
import { ProjectTemplateTask } from '../../types';

function* commonGenerator(action: StoreActionProps<TaskIdPayload>, dir: 0 | 1) {
  try {
    const {
      payload: { taskId, payload: newTaskPayload },
    } = action;

    const task: ProjectTemplateTask = yield select(selectTemplateTask(taskId));

    const newTask = {
      taskId: floatUid(),
      ...newTaskPayload,
      isNew: true,
    };

    if (task.projectPhase) {
      yield put(
        createProjectTemplateTask({
          task: newTask,
          projectPhaseId: task.projectPhase.projectPhaseId,
          insertAt: {
            id: converToEntityId(task.taskId, PhaseEntityType.Task),
            dir,
          },
        }),
      );
    } else {
      yield put(
        createProjectTemplateSubTask({
          task: newTask,
          parentTaskId: task.parentTask.taskId,
          insertAt: {
            id: task.taskId,
            dir,
          },
        }),
      );
    }
  } catch (error) {
    logger.error('an error while adding a task', { error });

    message.error('There was an error while adding a task');
  }
}

function* addTaskBelowProjectTemplateSaga(
  action: StoreActionProps<TaskIdPayload>,
) {
  yield commonGenerator(action, 1);
}

export function* watchAddTaskBelowProjectTemplateSaga(): Generator {
  yield takeLatest(
    addTaskBelowProjectTemplate.type,
    addTaskBelowProjectTemplateSaga,
  );
}

function* addTaskAboveProjectTemplateSaga(
  action: StoreActionProps<TaskIdPayload>,
) {
  yield commonGenerator(action, 0);
}

export function* watchAddTaskAboveProjectTemplateSaga(): Generator {
  yield takeLatest(
    addTaskAboveProjectTemplate.type,
    addTaskAboveProjectTemplateSaga,
  );
}
